import { motion } from "framer-motion";
import { useLang } from "@/lang";
import { Reveal, Eyebrow } from "@/components/Reveal";

const Strategy = () => {
  const { t } = useLang();

  return (
    <section id="methode" data-testid="strategy-section" className="relative overflow-hidden bg-bei-navy py-20 sm:py-28 lg:py-36">
      <div className="grid-overlay absolute inset-0" />
      <div className="absolute -right-40 top-0 h-[500px] w-[500px] rounded-full bg-bei-brand/15 blur-[160px]" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl sm:mb-24">
          <Reveal>
            <Eyebrow>{t.method.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              {t.method.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
              {t.method.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
          {t.method.steps.map((step, i) => (
            <motion.div
              key={step.n}
              data-testid={`method-step-${step.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-bei-navy p-7 transition-colors duration-500 hover:bg-bei-deep sm:p-8"
            >
              <span className="font-mono text-sm font-semibold text-bei-cyan">{step.n}</span>
              <div className="mt-16 h-px w-8 bg-bei-cyan/50 transition-all duration-500 group-hover:w-full sm:mt-24" />
              <h3 className="mt-5 font-display text-lg font-bold text-white sm:text-xl">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategy;
